import type { ProductInformationViewModel } from 'autogen/swagger/all';
import { useTranslation } from 'react-i18next';
import { Piece } from 'autogen/translation-keys/trans-website-product-priceinfo';
import type { IPriceModule } from './types';

// eslint-disable-next-line import/prefer-default-export
export function useMapPriceInfoToIPriceModule(
    priceInfo: ProductInformationViewModel['priceInfo'],
    showPossibleAdditionalDeliveryCost: ProductInformationViewModel['showPossibleAdditionalDeliveryCost']
): IPriceModule {
    const { t } = useTranslation();
    const { price, onDiscount, priceBefore, priceLabel, minimumSalesQuantity, saveLabel, recommendedPriceLabel } =
        priceInfo;

    return {
        price: minimumSalesQuantity > 1 ? `${t(Piece)} ${price}` : price,
        priceLabel,
        onDiscount,
        priceBefore,
        priceSaving: onDiscount ? saveLabel : undefined,
        showPossibleAdditionalDeliveryCost,
        recommendedPrice: recommendedPriceLabel
    };
}
